import { createContext } from "react";

export interface SidebarContextValue {
  collapsed: boolean;
}

export const SidebarContext = createContext<SidebarContextValue>({ collapsed: false });
